<template>
  <div id="shipping-multichannel" class="panel-body">
    <p class="text-size-20">STOCKCREW倉庫の商品に対し出荷依頼を作成することができます </p>
    <div class="mr-t-15 text-warning bg-warning font-bold" style="margin-left: 30px; width: 850px;">
      <span style="padding: 10px;">14:30までの登録は当日出荷、14:30以降の登録は翌日出荷となります。</span>
    </div>
    <div>
      <div class="mr-t-20" style="min-width: 1500px;">
        <div class="flexbox gap-15">
          <svg width="50" height="50">
            <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
            <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">1</text>
          </svg>
          <span class="font-bold text-size-16 text-primary">基本情報入力</span>
        </div>
        <div class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
          <div class="box-delivery-name m-b-md">
            <div class="row">
              <div class="col-md-2 col-lg-1 w-150">
                <div class="delivery-name"><strong>出荷名</strong></div>
              </div>
              <div class="col-md-10 col-lg-7">
                <input type="text" :class="['form-control', shippingName ? '' : 'bg-no-input']" v-model.trim="shippingName">
                <div>※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。</div>
                <div v-if="validateErrors.shippingName" class="text-red"><b>{{ validateErrors.shippingName}}</b></div>
              </div>
            </div>
          </div>
          <div class="m-b-md">
            <div class="row">
              <div class="col-md-2 col-lg-1 w-150">
                <div class="delivery-name"><strong>依頼番号(任意)</strong></div>
              </div>
              <div class="col-md-10 col-lg-7">
                <div class="flexbox gap-10">
                  <input type="text" class="form-control w-500" :class="[validateRequestNo() ? '' : 'bg-no-input']" v-model.trim="requestNo">
                  半角英数字、ハイフンのみ入力可
                </div>
                <div>※ショップの注文番号等をご入力ください。 送り状ラベルに表示されます。</div>
                <div v-if="validateErrors.requestNo" class="text-red"><b>{{ validateErrors.requestNo}}</b></div>
              </div>
            </div>
          </div>
          <div class="box-origin-info-default m-b-sm">
            <div class="row">
              <div class="col-md-2 col-lg-1 w-150">
                <div class="m-b-sm"><strong>発送元情報</strong></div>
              </div>
              <div class="col-md-9 col-lg-10">
                <div v-if="shippingInfo" class="delivery-info-default">
                  <div>{{ shippingInfo.name }}</div>
                  <div>
                    {{ shippingInfo.postalCode }} &nbsp;&nbsp;&nbsp;{{ shippingInfo.prefecture }} {{ shippingInfo.address1 }} {{ shippingInfo.address2 }}
                  </div>
                  <div>{{ shippingInfo.phoneNo }}</div>
                </div>
                <a href="javascript:void(0)" class="text--underline" @click.prevent="openModalShippingMultichannelInfo()">登録・変更はこちら</a>
                <div v-if="validateErrors.shippingInfo" class="text-red"><b>{{ validateErrors.shippingInfo}}</b></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mr-t-20" style="min-width: 1500px;">
        <div class="flexbox gap-15">
          <svg width="50" height="50">
            <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
            <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">2</text>
          </svg>
          <span class="font-bold text-size-16 text-primary">お届け先情報入力</span>
        </div>
        <div class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px; height: 150px;">
          <div v-if="deliveryInfo" class="m-b-sm">
            <div class="row">
              <div class="pd-l-15 pd-r-15">
                <b class="w-130">お届け先名：</b>
                {{ deliveryInfo.name }}
              </div>
            </div>
            <div class="row">
              <div class="pd-l-15 pd-r-15">
                <b class="w-130">郵便番号：</b>
                {{ deliveryInfo.postalCode }}
                <b class="w-130 pd-l-30">住所：</b>
                {{ deliveryInfo.prefecture }} {{ deliveryInfo.address1 }} {{ deliveryInfo.address2 }}
              </div>
            </div>
            <div class="row">
              <div class="pd-l-15 pd-r-15">
                <b class="w-130">電話番号：</b>
                {{ deliveryInfo.phoneNo }}
              </div>
            </div>
          </div>
          <div v-if="validateErrors.deliveryInfo" class="text-red"><b>{{ validateErrors.deliveryInfo}}</b></div>
          <button type="button" class="btn btn-primary check-maintenance" @click="openModalRegisterDeliveryInfo()">お届け先情報を入力</button>
        </div>
      </div>
      <div class="mr-t-20" style="min-width: 1500px;">
        <div class="flexbox gap-15">
          <svg width="50" height="50">
            <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
            <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">3</text>
          </svg>
          <span class="font-bold text-size-16 text-primary">商品情報入力</span>
        </div>
        <div id="product-input" class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
          <fixed-header v-show="isShowFixedHeader" :textBtnRegister="'出荷依頼'" @handleClickAdd="openModalProductAdd()" @handleClickRegister="submitValidate()"/>
          <p class="">出荷する商品を選択し、商品情報を入力してください。</p>
          <div class="flexbox justify-between">
            <button type="button" class="btn btn-primary check-maintenance" @click.prevent="openModalProductAdd()">商品選択</button>
            <button v-if="selectedProducts.length" type="button" class="btn btn-primary check-maintenance" @click.prevent="handleGetStorageSize()">保管サイズを再取得</button>
          </div>
          <div v-if="selectedProducts.length" class="table-selected-products">
            <table class="full-width">
              <thead>
                <tr>
                  <th class="text-center w-150">出荷する商品</th>
                  <th style="min-width: 500px;"></th>
                  <th class="text-right w-200">保管サイズ</th>
                  <th class="text-right w-100">在庫数</th>
                  <th class="w-120">出荷予定数</th>
                  <th class="text-center w-100">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(selectedProduct, index) in selectedProducts" :key="index">
                  <td class="text-center">
                    <div class="box-selected-product-image w-40">
                      <img :src="selectedProduct.image" alt="" class="selected-product-image img-responsive">
                    </div>
                    <div :class="`box-delivery-judgment-status ${getJudgmentStatusClass(selectedProduct.status_str)}`">{{ selectedProduct.status_str }}</div>
                  </td>
                  <td>
                    <div class="m-b-xs">{{ selectedProduct.itemName }}</div>
                    <div><b>ASIN：</b>{{selectedProduct.asin}} / <b>SKU：</b>{{ selectedProduct.sku }} </div>
                    <div><b>商品ID：</b>{{selectedProduct.itemId}} / <b>商品ラベル：</b>{{ selectedProduct.goodsLabel }}</div>
                  </td>
                  <td colspan="3">
                    <tr>
                      <td class="text-right w-220 no-borders no-padding">
                        <span class="">{{ selectedProduct.sizeName }}</span> <br>
                        <span class="">{{ selectedProduct.storageSize }}</span>
                      </td>
                      <td class="text-right w-100 no-borders no-padding">
                        <span class="">{{ formatNumber(selectedProduct.scQuantity) }} 個</span>
                      </td>
                      <td class="no-borders">
                        <input type="text" class="form-control expected-delivery-number text-right mr-l-10" :class="parseInt(selectedProduct.quantity) && parseInt(selectedProduct.quantity) <= parseInt(selectedProduct.scQuantity) ? '' : 'bg-no-input'" v-model="selectedProduct.quantity" @input="selectedProduct.quantity = handleInputQuantity(selectedProduct.quantity)" @blur="updateStorageProducts">
                      </td>
                    </tr>
                    <div v-if="validateErrors.quantity[selectedProduct.itemId] && validateErrors.quantity[selectedProduct.itemId].length" class="text-red text-right"><b>{{ validateErrors.quantity[selectedProduct.itemId][0]}}</b></div>
                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-delete-selected-product check-maintenance" @click.prevent="deleteSelectedProduct(selectedProduct)">削除</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="empty-products text-center">
            <h3 class="m-b-xl text-center"><strong>商品選択より、出荷する商品を選択してください。</strong></h3>
          </div>
        </div>
      </div>
      <div class="mr-t-20" style="min-width: 1500px;">
        <div class="flexbox gap-15">
          <svg width="50" height="50">
            <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
            <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">4</text>
          </svg>
          <span class="font-bold text-size-16 text-primary">配送方法入力</span>
        </div>
        <div class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px; min-height: 300px;">
          <p>ご希望の配送方法を選択してください。</p>
          <div class="shipping-method">
            <div class="mr-r-10" style="color: #ffae2c;">
              <i class="fa fa-exclamation-triangle text-size-20" aria-hidden="true"></i>
            </div>
            <div>
              <span class="text-red">配送方法を選択する際は、以下の点にご注意ください。</span>
              <div class="note">
                指定した配送方法での梱包が難しく商品がPE袋や段ボールに収まらない場合は、以下のような対応をとらせていただきます。
                <ul>
                  <li>出荷指示を自動的にキャンセル。</li>
                  <li>適切な配送方法へ自動的に切り替え。※配送を切り替えた場合、配送切替費用がかかります。</li>
                </ul>
                <a href="https://www.canva.com/design/DAGjizk6zLU/-UQBwTyh_GZMp_73hfrbMA/view" class="text--underline" target="_blank">> 詳しくはこちら</a>
              </div>
              <div class="shipping-method--options">
                <div v-if="validateErrors.selectedMethod" class="text-red"><b>{{ validateErrors.selectedMethod}}</b></div>
                <div class="radio-group">
                  <div class="radio-option" :class="{ 'selected': selectedMethod == '0'}">
                    <label>
                      <input type="radio" value="0" v-model="selectedMethod">  PE袋で配送する
                    </label>
                  </div>
                  <div v-show="selectedMethod == '0'" class="radio-group">
                    <div class="sub-options" :class="{ 'selected': transporterCode == '1004'}">
                      <label>
                        <input type="radio" value="1004" v-model="transporterCode">  ネコポス
                      </label>
                    </div>
                    <div class="sub-options" :class="{ 'selected': transporterCode == '1009'}">
                      <label>
                        <input type="radio" value="1009" v-model="transporterCode">  宅急便（60サイズ以上）
                      </label>
                    </div>
                  </div>
                  <div class="radio-option" :class="{ 'selected': selectedMethod == '1'}">
                    <label>
                      <input type="radio" value="1" v-model="selectedMethod">  ダンボールで配送する
                    </label>
                  </div>
                  <div v-show="selectedMethod == '1'" class="radio-group">
                    <div class="sub-options" :class="{ 'selected': transporterCode == '1007'}">
                      <label>
                        <input type="radio" value="1007" v-model="transporterCode">  ネコポス
                      </label>
                    </div>
                    <div class="sub-options" :class="{ 'selected': transporterCode == '1001'}">
                      <label>
                        <input type="radio" value="1001" v-model="transporterCode">  宅急便（60サイズ以上）
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedProducts.length" class="text-center m-b-md m-t-md">
            <button type="button" class="btn btn-primary custom-btn check-maintenance" @click.prevent="submitValidate">
              出荷依頼
              <i class="fa fa-check fa-lg mr-l-5" aria-hidden="true"></i>
            </button>
          </div>
      </div>
    </div>
    <shipping-multi-channel-product-add
      v-if="openProductAddModal"
      ref="shippingMultiProductAddModal"
      :iconUrls="iconUrls"
      :selectedProducts="storageSelectedProducts"
      @close="closeModalProductAdd"
      @handleSelectedProduct="handleSelectedProduct"
      @handleSelectedProducts="handleSelectedProducts"
    />
    <modal-alert
      v-if="openAlertValidateFailsModal"
      :message="alertValidateFailsMessage"
      :customHide="true"
      @close="closeModalAlertValidateFails"
    />
    <modal-confirm
      v-if="openProductsAddConfirmModal"
      :message="productsAddConfirmMessage"
      @confirm="registerShippingMultichannel"
      @close="closeModalConfirmProductsAdd"
    />
    <modal-alert
      v-if="openAlertProductsAddedModal"
      :message="alertProductsAddedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeModalAlertProductsAdded"
    />
    <shipping-multichannel-info-modal
      v-if="openShippingMultichannelInfoModal"
      ref="shippingMultichannelInfoModal"
      @close="closeModalShippingMultichannelInfo"
      @openModalRegisterShippingInfo="openModalRegisterShippingInfo"
      @setDefaultInfoSuccess="registerShippingInfo"
    />
    <register-shipping-info-modal
      v-if="openRegisterShippingInfoModal"
      ref="registerShippingInfoModal"
      @close="closeModalRegisterShippingInfo"
      @registerShippingInfo="registerShippingInfo"
    />
    <register-delivery-info-modal
      v-if="openRegisterDeliveryInfoModal"
      ref="registerDeliveryInfoModal"
      :deliveryInfo="deliveryInfo"
      @close="closeModalRegisterDeliveryInfo"
      @updatedDeliveryInfo="updatedDeliveryInfo"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Util from '@/common/utility'
import ModalAlert from '@/components/ModalAlert'
import ModalConfirm from '@/components/ModalConfirm'
import ShippingMultiChannelProductAdd from '@/view/warehouseSc/components/ShippingMultiChannelProductAdd'
import ShippingMultichannelInfoModal from '@/view/warehouseSc/components/ShippingMultichannelInfoModal'
import RegisterShippingInfoModal from '@/view/warehouseSc/components/RegisterShippingInfoModal'
import RegisterDeliveryInfoModal from '@/view/warehouseSc/components/RegisterDeliveryInfoModal'
import FixedHeader from '@/view/warehouseAcross/components/FixedHeader'
import WarehouseScService from '@/services/warehousescservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ModalAlert,
    ModalConfirm,
    ShippingMultiChannelProductAdd,
    RegisterShippingInfoModal,
    RegisterDeliveryInfoModal,
    ShippingMultichannelInfoModal,
    FixedHeader
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loader: null,
      openShippingMultichannelInfoModal: false,
      openProductsAddConfirmModal: false,
      openAlertProductsAddedModal: false,
      openProductAddModal: false,
      openAlertValidateFailsModal: false,
      openRegisterShippingInfoModal: false,
      openRegisterDeliveryInfoModal: false,
      isShowFixedHeader: false,
      shippingNo: null,
      shippingId: null,
      shippingName: null,
      requestNo: null,
      deliveryInfo: null,
      selectedMethod: null,
      transporterCode: null,
      validateErrors: {
        shippingName: '',
        requestNo: '',
        quantity: {},
        shippingInfo: '',
        deliveryInfo: '',
        selectedMethod: ''
      },
      shippingInfo: {},
      storageSelectedProducts: [],
      alertValidateFailsMessage: '入力エラーです。<br/>入力内容を確認、修正後にご登録をお願いします。',
      productsAddConfirmMessage: '出荷情報を登録します。 よろしいですか？'
    }
  },
  created () {
    if (history.state && history.state.shippingId && history.state.shippingNo) {
      this.getShippingDetail(history.state.shippingNo, history.state.shippingId)
    } else {
      this.getSelectedProducts()
      this.fetchShippingInfo()
    }
  },
  computed: {
    ...mapGetters({
      shippingMultichannelInfoDefaultItem: 'scshippingmultichannelinfo/getDefaultItem',
      iconUrls: 'getWareHouseIcons'
    }),
    storageSelectedProductsName () {
      return `${this.$store.getters.getUser.sellerId}-ScShippingMultiChannelSelectedProducts`
    },
    selectedProducts () {
      return this.storageSelectedProducts
    },
    alertProductsAddedMessage () {
      return `
        出荷情報を受付けました。 <br>
        出荷管理番号（出荷ID） <br>
        <span class="pd-l-25">${this.shippingNo} (${this.shippingId})</span>
        <div>
          ご登録頂いた情報は、出荷状況照会画面より確認いただけます。<br>
          また、出荷が完了した際はメールにて通知させていただきます。<br>
        </div>
      `
    }
  },
  methods: {
    openModalShippingMultichannelInfo () {
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.multi_channel_shipping.click_regis_or_update_shipping_info_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      this.openShippingMultichannelInfoModal = true
    },
    closeModalShippingMultichannelInfo () {
      $('#shipping-info-modal').modal('hide')
      this.openShippingMultichannelInfoModal = false
    },
    openModalRegisterShippingInfo () {
      this.closeModalShippingMultichannelInfo()
      this.openRegisterShippingInfoModal = true
    },
    closeModalRegisterShippingInfo () {
      $('#register-shipping-info-modal').modal('hide')
      this.openRegisterShippingInfoModal = false
    },
    openModalRegisterDeliveryInfo () {
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.multi_channel_shipping.click_input_receipt_info_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      this.openRegisterDeliveryInfoModal = true
    },
    closeModalRegisterDeliveryInfo () {
      $('#register-delivery-info-modal').modal('hide')
      this.openRegisterDeliveryInfoModal = false
    },
    updatedDeliveryInfo (deliveryInfo) {
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.multi_channel_shipping.click_regis_receipt_info_btn,
        properties: deliveryInfo
      }
      EventService.postTrackLog(logParams)
      this.deliveryInfo = deliveryInfo
      this.closeModalRegisterDeliveryInfo()
    },
    closeModalProductAdd () {
      $('#shipping-product-add-modal').modal('hide')
      this.openProductAddModal = false
    },
    openModalAlertValidateFails () {
      this.openAlertValidateFailsModal = true
    },
    closeModalAlertValidateFails () {
      $('#myModal').modal('hide')
      this.openAlertValidateFailsModal = false
    },
    openModalConfirmProductsAdd () {
      if (this.isValidateFails) return
      this.openProductsAddConfirmModal = true
    },
    closeModalConfirmProductsAdd () {
      $('#confirm-alert').modal('hide')
      this.openProductsAddConfirmModal = false
    },
    openModalAlertProductsAdded () {
      this.openAlertProductsAddedModal = true
    },
    closeModalAlertProductsAdded () {
      $('#myModal').modal('hide')
      this.openAlertProductsAddedModal = false
      this.shippingName = null
      this.shippingNo = null
      this.shippingId = null
      this.$router.push({
        name: 'Warehouse sc',
        params: {
          tab: 'shipping',
          subTab: 'shipping-status-inquiry'
        }
      })
    },
    async getShippingDetail (shippingNo, shippingId) {
      this.loader = this.$loading.show()
      let params = {
        shippingNo: shippingNo,
        shippingId: shippingId
      }
      await WarehouseScService.getShippingMultiDetail(params)
        .then((response) => {
          this.shippingName = response.data.shippingName
          this.requestNo = response.data.requestNo
          this.deliveryInfo = response.data.deliveryInfo
          this.shippingInfo = response.data.shippingInfo
          localStorage.removeItem(this.storageSelectedProductsName)
          localStorage.setItem(this.storageSelectedProductsName, JSON.stringify(response.data.shippingGoods))
          this.storageSelectedProducts = response.data.shippingGoods
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    getSelectedProducts () {
      this.storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageSelectedProductsName) || '[]')
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    deleteSelectedProduct (product) {
      this.storageSelectedProducts = this.storageSelectedProducts.filter(item => item.itemId !== product.itemId)
      localStorage.setItem(this.storageSelectedProductsName, JSON.stringify(this.storageSelectedProducts))
    },
    handleSelectedProduct (product) {
      let storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageSelectedProductsName) || '[]')
      let selectedProducts = [...storageSelectedProducts, product]
      localStorage.setItem(this.storageSelectedProductsName, JSON.stringify(selectedProducts))
      this.storageSelectedProducts = selectedProducts
    },
    handleSelectedProducts (products) {
      let storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageSelectedProductsName) || '[]')
      let selectedProducts = [...storageSelectedProducts, ...products]
      localStorage.setItem(this.storageSelectedProductsName, JSON.stringify(selectedProducts))
      this.storageSelectedProducts = selectedProducts
    },
    updateStorageProducts () {
      let selectedProducts = this.storageSelectedProducts
      localStorage.removeItem(this.storageSelectedProductsName)
      this.storageSelectedProducts = []
      this.handleSelectedProducts(selectedProducts)
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    openModalProductAdd () {
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.multi_channel_shipping.click_select_product_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      this.openProductAddModal = true
    },
    clearStorage () {
      localStorage.removeItem(this.storageSelectedProductsName)
      this.storageSelectedProducts = []
    },
    async submitValidate () {
      this.loader = this.$loading.show()
      let params = {
        shippingGoods: this.storageSelectedProducts
      }
      await WarehouseScService.getShippingStockInfo(params)
        .then((response) => {
          this.storageSelectedProducts = response.data
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })

      this.validateInput()
    },
    validateInput () {
      const required = '※必ず入力してください'
      const validateMin = '※1以上の数値を入力してください'
      const validateMax = '※在庫数以内で入力してください'
      const duplicateName = '※発送元名はお届け先名と重複してはいけません。'
      const validateRequestNumber = '※半角英字、半角数字またはハイフンのみをご入力ください。'
      const shippingMethodRequire = '※配送方法を選択してください'

      this.isValidateFails = false
      this.validateErrors = {
        shippingName: '',
        requestNo: '',
        quantity: {},
        shippingInfo: '',
        deliveryInfo: '',
        selectedMethod: ''
      }

      const setError = (field, message) => {
        this.validateErrors[field] = message
        this.isValidateFails = true
      }

      if (!this.shippingName) setError('shippingName', required)

      if (this.requestNo && !this.validateRequestNo()) {
        setError('requestNo', validateRequestNumber)
      }

      if (!this.shippingInfo || !Object.keys(this.shippingInfo).length) {
        setError('shippingInfo', required)
      }

      if (!this.deliveryInfo || !Object.keys(this.deliveryInfo).length) {
        setError('deliveryInfo', required)
      } else {
        if (!this.validateErrors.shippingInfo && this.deliveryInfo.name === this.shippingInfo.name) {
          setError('shippingInfo', duplicateName)
          setError('deliveryInfo', duplicateName)
        }
      }

      if (!this.selectedMethod || !this.transporterCode) {
        setError('selectedMethod', shippingMethodRequire)
      }

      this.storageSelectedProducts.forEach((product) => {
        let quantity = parseInt(product.quantity)
        let itemId = product.itemId
        this.validateErrors.quantity[itemId] = []
        if (isNaN(quantity)) {
          this.validateErrors.quantity[itemId][0] = required
          this.isValidateFails = true
        } else if (quantity === 0) {
          this.validateErrors.quantity[itemId][0] = validateMin
          this.isValidateFails = true
        } else if (quantity > product.scQuantity) {
          this.validateErrors.quantity[itemId][0] = validateMax
          this.isValidateFails = true
        }
      })
      this.updateStorageProducts()

      this.isValidateFails ? this.openModalAlertValidateFails() : this.openModalConfirmProductsAdd()
    },
    registerShippingMultichannel () {
      if (this.isValidateFails) return

      this.loader = this.$loading.show()

      let params = {
        shippingGoods: this.storageSelectedProducts,
        shippingName: this.shippingName,
        requestNo: this.requestNo,
        shippingInfo: this.shippingInfo,
        deliveryInfo: this.deliveryInfo,
        transporterCode: this.transporterCode
      }
      WarehouseScService.registerShippingMultichannel(params)
        .then((response) => {
          this.closeModalConfirmProductsAdd()
          this.shippingNo = response.data.shippingNo
          this.shippingId = response.data.shippingId
          this.loader && this.loader.hide()
          this.openModalAlertProductsAdded()
          this.clearStorage()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          let logParams = {
            name: eventCode.warehouse_sc.shipping_tab.multi_channel_shipping.click_request_shipping_btn,
            properties: {
              shippingNo: this.shippingNo,
              shippingId: this.shippingId
            }
          }
          EventService.postTrackLog(logParams)
          this.loader && this.loader.hide()
        })
    },
    validateRequestNo () {
      if (!this.requestNo) {
        return true
      }
      const regex = /^[a-zA-Z0-9-ｰー]{1,100}$/
      if (regex.test(this.requestNo)) {
        return true
      } else {
        return false
      }
    },
    registerShippingInfo () {
      this.updateShippingInfo(this.shippingMultichannelInfoDefaultItem)
    },
    updateShippingInfo (data) {
      if (data) {
        this.shippingInfo = {
          name: data.name,
          postalCode: data.postalCode,
          prefecture: data.prefecture,
          address1: data.address1,
          address2: data.address2,
          phoneNo: data.phoneNo
        }
      } else {
        this.shippingInfo = {
          name: '',
          postalCode: '',
          prefecture: '',
          address1: '',
          address2: '',
          phoneNo: ''
        }
      }
    },
    fetchShippingInfo () {
      this.loader = this.$loading.show()
      WarehouseScService.getShippingMultichannelInfo()
        .then((response) => {
          this.$store.commit('scshippingmultichannelinfo/setItems', response.data)
          if (Object.keys(this.shippingInfo).length === 0 && response.data.length > 0) {
            const shippingInfo = response.data.find(item => { return item.defFlg === '1' })
            this.updateShippingInfo(shippingInfo)
          }
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    handleScroll () {
      const fixedHeader = document.getElementById('product-input')
      const initialOffset = fixedHeader.getBoundingClientRect().top + window.scrollY
      this.isShowFixedHeader = window.scrollY >= initialOffset
    },
    handleInputQuantity (value) {
      return value.replace(/[^0-9]/g, '').replace(/^0+/, '')
    },
    handleGetStorageSize () {
      this.loader = this.$loading.show()
      const params = {
        shippingGoods: this.storageSelectedProducts
      }
      WarehouseScService.getStorageSize(params)
        .then((response) => {
          this.storageSelectedProducts = response.data
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_sc.shipping_tab.multi_channel_shipping.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)

    window.addEventListener('scroll', this.handleScroll)
  },
  watch: {
    selectedMethod () {
      this.transporterCode = null
    }
  },
  unmouted () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style scoped>
.judgment-status-stop {
  background-color: #a6a6a6;
  color: #f2f2f2;
}
.judgment-status-danger {
  background-color: #c00000;
  color: #fff;
}
.step-rectangle {
  border: 2px solid #008cc6;
  border-radius: 8px;
  padding: 5px;
  width: 350px;
  height: 70px;
}
.text-primary {
  color: #008cc6;
}
.table-selected-products {
  margin-top: 10px;
  /* overflow: auto; */
  padding: 0
}
.table-selected-products table {
  border: 1px solid #ccc
}
.table-selected-products th, .table-selected-products td{
  padding: 5px 10px;
  min-width: 120px;
  height: auto;
  border-bottom: 1px solid #ccc;
}
.table-selected-products th {
  color: #595959;
  background-color: #deebf7;
}
.td-vertical-top {
  vertical-align: top;
}
#shipping-multichannel {
  overflow: auto;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.text-warning {
  background-color: #fff2cc;
}
.bg-warning {
  color: #843c0b;
}
.custom-btn {
  font-size: 20px;
  padding: 10px 50px;
  border-radius: 8px;
  background-color: #0070c0;
}
.shipping-method {
  display: flex;
  margin-left: 30px;
}
.note {
  border: 1px solid #ed7d31;
  background-color: #fdf1e9;
  padding: 10px;
}
.shipping-method--options {
  margin-top: 20px;
}
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.radio-option, .sub-options {
  padding: 8px 16px;
  background-color: #f2f2f2;
}
.radio-option label, .sub-options label{
  font-weight: unset;
}
.radio-option label:hover, .sub-options label:hover{
  cursor: pointer;
}
.radio-option input[type="radio"], .sub-options input[type="radio"] {
  margin-right: 8px;
}
.radio-option.selected, .sub-options.selected {
  background-color: #e3f2fd;
}
.sub-options {
  margin-left: 30px;
  width: 300px;
}
</style>
<style>
#shipping-multichannel .bg-no-input {
  background-color: #fdefef !important;
}
#shipping-multichannel .row {
  margin-left: -15px;
  margin-right: -15px;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/MultiChannelShipping.vue